import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { useGetBoxingWorkOrders } from "../../hooks";
import ShipmentDetailsDialogDetails from "./ShipmentDetailsDialogDetails";
import ShipmentDetailsDialogBoxData from "./ShipmentDetailsDialogBoxData";
import { StyledFormStack } from "./styles";

const ShipmentDetailsDialogForm = ({
  disabled = false,
  shipment = {},
  locationId = 1,
  onOptionsChange,
}) => {
  const { watch } = useFormContext();
  const customerId = watch("customerId");
  const stationId = watch("stationId");
  const returning = watch("returning");

  const includedWorkOrders = shipment?.routes || shipment?.workOrders;
  const workOrders = includedWorkOrders
    ?.map((r) => r?.workOrderId || r?.routeId)
    .filter(Boolean);
  const { data, isLoading } = useGetBoxingWorkOrders({
    customerId,
    stationId,
    returning,
    locationId,
    workOrders,
  });

  const options = data?.rows || [];

  // Surface the latest WO option set up to the parent so it can decide which
  // are still open after the shipment is created (and prompt the user).
  useEffect(() => {
    onOptionsChange?.(options);
  }, [data, onOptionsChange]);

  const props = {
    disabled,
    shipment,
    options,
    isLoading,
    useStation: returning,
    locationId,
  };

  return (
    <StyledFormStack>
      <ShipmentDetailsDialogDetails {...props} />
      <ShipmentDetailsDialogBoxData {...props} />
    </StyledFormStack>
  );
};

export default ShipmentDetailsDialogForm;
